import { render, staticRenderFns } from "./Administrators.vue?vue&type=template&id=422e4782&scoped=true&"
import script from "./Administrators.vue?vue&type=script&lang=js&"
export * from "./Administrators.vue?vue&type=script&lang=js&"
import style0 from "./Administrators.vue?vue&type=style&index=0&id=422e4782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e4782",
  null
  
)

export default component.exports